import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "container-fluid" };
const _hoisted_2 = {
    class: "row d-block; d-md-none px-1 py-2 [ JS_blueStickyBoxFadeOut ]",
    style: { "position": "fixed", "bottom": "0", "z-index": "3", "background": "#fff", "width": "100%", "box-shadow": "-2px 0 4px #e5e5e5" }
};
const _hoisted_3 = {
    class: "col-4 pr-0",
    style: { "line-height": "1.3em" }
};
const _hoisted_4 = { class: "font6 strong mt-1 mr-1" };
const _hoisted_5 = { class: "price [ JS_blueProductPrice ]" };
const _hoisted_6 = { class: "col-8 font2 strong pl-1" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _a;
    const _component_blue_add_cart = _resolveComponent("blue-add-cart");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("span", _hoisted_5, _toDisplayString((_a = _ctx.currentProduct) === null || _a === void 0 ? void 0 : _a.currentPrice), 1),
                    _cache[0] || (_cache[0] = _createTextVNode(" € ", -1))
                ]),
                _cache[1] || (_cache[1] = _createElementVNode("div", {
                    class: "font7",
                    style: { "line-height": "1.1em" }
                }, [
                    _createTextVNode(" Inkl. MwSt. "),
                    _createElementVNode("a", {
                        href: "#",
                        title: "MwSt. und Versand Info",
                        class: "[ JS_stickyPriceDetailLink ] link-gray font7"
                    }, " Details ")
                ], -1))
            ]),
            _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_blue_add_cart, {
                    class: "px-1 py-2 font6-responsive",
                    style: { "line-height": "1em", "min-height": "2.7rem" }
                })
            ])
        ])
    ]));
}
